import { SVGProps, Ref, forwardRef } from 'react';

export const SquaresIntersectedFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 5.834C0 1.167.667.5 5.333.5s5.334.667 5.334 5.334-.667 5.333-5.334 5.333S0 10.501 0 5.834m5.333 4.33c0-4.667.667-5.333 5.333-5.333S16 5.497 16 10.164s-.667 5.333-5.334 5.333-5.333-.666-5.333-5.333"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
SquaresIntersectedFilledSize16Glyph.displayName = 'SquaresIntersectedFilledSize16Glyph';
